import React, { useState } from "react";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import RadarMap from "./RadarMap";
import DebugEventFeed from "./DebugEventFeed";
import CalibrationPanel from "./CalibrationPanel";

function getStatusChip(status) {
  if (status === "streaming") {
    return { label: "Streaming", color: "primary" };
  }
  if (status === "requested") {
    return { label: "Requested — waiting for ACK", color: "default" };
  }
  return { label: "Idle", color: "default" };
}

export default function AnticheatDebugger({
  state,
  activeMatches,
  onSelectMatch,
  onToggle,
}) {
  const statusChip = getStatusChip(state.status);
  const [calibrating, setCalibrating] = useState(false);

  return (
    <div style={{ padding: 16 }}>
      <Paper
        style={{
          padding: 12,
          display: "flex",
          gap: 12,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Select
          value={state.selectedMatchId || ""}
          displayEmpty
          onChange={(e) => onSelectMatch(e.target.value)}
          style={{ minWidth: 260 }}
        >
          <MenuItem value="" disabled>
            Select an active match…
          </MenuItem>
          {activeMatches.map((m) => (
            <MenuItem key={m.matchId} value={m.matchId}>
              {(m.map || "?")} — {m.matchId}
            </MenuItem>
          ))}
        </Select>

        <Button
          variant="contained"
          color="primary"
          disabled={!state.selectedMatchId || state.status === "requested" || state.status === "streaming"}
          onClick={() => onToggle(true)}
        >
          Start instrumentation
        </Button>

        <Button
          variant="outlined"
          disabled={!state.selectedMatchId || state.status === "idle"}
          onClick={() => onToggle(false)}
        >
          Stop
        </Button>

        <Chip label={statusChip.label} color={statusChip.color} />

        <Typography variant="body2">
          {state.roundNumber != null ? `Round ${state.roundNumber} · tick ${state.serverTick}` : ""}
        </Typography>

        <Button
          variant={calibrating ? "contained" : "outlined"}
          onClick={() => setCalibrating((v) => !v)}
          style={{ marginLeft: "auto" }}
        >
          {calibrating ? "Close calibration" : "Calibrate map"}
        </Button>

        {state.error && (
          <Typography variant="body2" color="error">
            {state.error}
          </Typography>
        )}
      </Paper>

      {calibrating ? (
        <div style={{ marginTop: 16 }}>
          <CalibrationPanel defaultMapId={state.mapName} />
        </div>
      ) : (
        <div style={{ display: "flex", gap: 24, marginTop: 16, flexWrap: "wrap" }}>
          <RadarMap mapName={state.mapName} players={state.players} liveSignals={state.liveSignals} />
          <DebugEventFeed events={state.events} />
        </div>
      )}
    </div>
  );
}
